var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.5 0.585938C4.076 0.585938 0.5 4.16194 0.5 8.58594C0.5 13.0099 4.076 16.5859 8.5 16.5859C12.924 16.5859 16.5 13.0099 16.5 8.58594C16.5 4.16194 12.924 0.585938 8.5 0.585938ZM8.5 14.9859C4.972 14.9859 2.1 12.1139 2.1 8.58594C2.1 5.05794 4.972 2.18594 8.5 2.18594C12.028 2.18594 14.9 5.05794 14.9 8.58594C14.9 12.1139 12.028 14.9859 8.5 14.9859ZM11.372 4.58594L8.5 7.45794L5.628 4.58594L4.5 5.71394L7.372 8.58594L4.5 11.4579L5.628 12.5859L8.5 9.71394L11.372 12.5859L12.5 11.4579L9.628 8.58594L12.5 5.71394L11.372 4.58594Z",
    fill: "#474747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.303eb6023f49be5814b3cd2ab099c052.svg";
export { ForwardRef as ReactComponent };